import { render, staticRenderFns } from "./wellbore.vue?vue&type=template&id=594eeed5&scoped=true"
import script from "./wellbore.vue?vue&type=script&lang=js"
export * from "./wellbore.vue?vue&type=script&lang=js"
import style0 from "./wellbore.vue?vue&type=style&index=0&id=594eeed5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594eeed5",
  null
  
)

export default component.exports